import { useFeature } from '@optimizely/react-sdk'

interface UseOptimizelyToggleProps {
  key: string
  internalToggle?: string
}

const useOptimizelyToggle = ({ key, internalToggle }: UseOptimizelyToggleProps): boolean => {
  const [isEnabled, values] = useFeature(key)

  if (internalToggle) {
    return isEnabled || values[key] === sessionStorage.getItem(internalToggle)
  }

  return isEnabled
}

export default useOptimizelyToggle
